import styled from "styled-components";
import colors from "../../../theme/colors";
import { FILE_ERRORS, IFileConfiguration } from "./Appearance";

export const BodyContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 24px 82px 0 80px;

    @media only screen and (max-width: 1050px){
        padding: 12px 60px 0 60px;
    }

    @media only screen and (max-width: 768px){
        padding: 12px 45px 0 30px;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 68px;
`;

export const TitleContent = styled.div`
    display: flex;
    margin-bottom: 64px;
`;

export const InputLabelFileContent = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 64px;
`;

export const LabelFile = styled.label`
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.body};
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 40px;
    width: 176px;
    height: 46px;

    @media only screen and (max-width: 1050px){
        padding: 8px;
        margin-left: 20px;
        font-size: 12px;
        width: 126px;
        height: 36px;
    }

`;

export const InputFile = styled.input.attrs({ type: 'file' })`
    display: none;
`;

export const FileConfigurationContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 16px;
`;

export const FileConfiguration = styled.span<IFileConfiguration>`
    color: ${(props) => props.uploadedFileErrorType !== FILE_ERRORS.NONE ? colors.error : ''};
`;

export const ImageLoadContainer = styled.div`
    display: flex;
`;

export const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    margin-left: 30px;
    margin-bottom: 64px;
`;

export const ImageContent = styled.div`
    display: flex;
    align-items: center;
    width: 90%;

    @media only screen and (max-width: 1597px){
        width: 100%;
    }

    @media only screen and (max-width: 1200px){
        flex-direction: column;
    }
`;

export const Imagem = styled.img`
    width: 30%;
    height: 100%;
    object-fit: contain;
    
    @media only screen and (max-width: 1200px){
        padding-bottom: 10px;
        width: 70%;
    }
`;

export const ImageFormatText = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 100%;

    @media only screen and (max-width: 1597px){
        padding-left: 10px;

    }
`;

export const IconsUploadContainer = styled.div`
    display: flex;
    margin-top: 20px;
`;

export const AttributeContainer = styled.div`
    position: relative;
    width: 400px;
`;